import { Box, Image } from '@chakra-ui/react';
import * as React from 'react';

export const AIAskTriggerIcon: React.FC = () => (
  <Box
    boxSize="5"
    borderRadius="full"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Image src="/aiask.png" alt="AI Ask" boxSize="5" />
  </Box>
);

export const AIAskHeaderIcon: React.FC = () => (
  <Box
    boxSize="10"
    borderRadius="full"
    bg="#1676CE"
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
  >
    <Image src="/aiask_white-background.png" alt="AI Ask" boxSize="6" />
  </Box>
);
